import { MigracionRadius } from "@/erp/configuracion-red/radius-migraciones/shared/constants/migraciones-radius.interface";
import { erpApi } from "@/shared/axios";
import { urlBackend } from "@/shared/constants";
import { AlertSeverityEnum, UseMutationsParams } from "@/shared/interfaces";
import { IBras, IBrasForm, IBrasPaginRes, IBrasParams } from "@/shared/interfaces/erp/configuracion-red/bras/bras.interface";
import { getUrlParamsFetch, handleAxiosError } from "@/shared/utils";
import { useUiStore } from "@/store/ui";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

const { get, post, put } = erpApi();

///* obtener bras
export const useFetchGetBras = (
  { params, enabled }: {
    params?: IBrasParams,
    enabled: boolean
  }
) => {
  return useQuery({
    queryKey: ['bras-rad-check'],
    queryFn: async () => {
      return await getBras(params);
    },
    enabled,
    gcTime: 0
  });
};

export const getBras = async (params?: IBrasParams) => {
  const queryParams = getUrlParamsFetch(params || {})
  const resp = await get<IBrasPaginRes>(`${urlBackend}api/v1/bras/?${queryParams}`, true);
  return resp;
};

///* obtener bras por su id
export const useFetchGetBrasById = (
  id: string,
  enabled = true
) => {
  return useQuery({
    queryKey: ['bras', id],
    queryFn: async () => {
      return await getBrasById(id);
    },
    enabled,
  });
};

export const getBrasById = async (id: string) => {
  const resp = await get<IBras>(`${urlBackend}api/v1/bras/${id}/`, true);
  return resp;
};

///* crear un bras
export const useFetchPostBras = (
  {
    navigate,
    returnUrl
  }: UseMutationsParams = {}
) => {

  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: async ({ data }: {
      data: IBrasForm
    }) => {
      return postBras(data);
    },
    onSuccess: (data) => {
      if (navigate && returnUrl) {
        navigate(returnUrl)
      }
      setAlert(true, data.message, AlertSeverityEnum.success);
    },
    onError: error => {
      handleAxiosError(error)
    },
    onSettled: () => {
    }
  });
}

export const postBras = async (data: IBrasForm) => {
  const resp = await post<IBras>(`${urlBackend}api/v1/bras/`, data, true);
  return resp;
}

///* actualizar bras

export const useFetchPutBras = ({
  navigate,
  returnUrl
}: UseMutationsParams = {}) => {

  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: async ({ id, data }: {
      id: string,
      data: IBrasParams
    }) => {
      return putBras(id, data);
    },
    onSuccess(data) {
      setAlert(true, data.message, AlertSeverityEnum.info);
      navigate && returnUrl && navigate(returnUrl)
    },
    onError: error => {
      handleAxiosError(error)
    },
    onSettled: () => {
    }
  });
}

export const putBras = async (id: string, data: IBrasParams) => {
  const resp = await put<IBras>(`${urlBackend}api/v1/bras/${id}/`, data, true);
  return resp;
}



///custom
export const usePostGenerarMigracionBras = (

) => {

  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: async ({ data }: {
      data: {bras:string, datos_migracion:MigracionRadius[]}
    }) => {
      return generarMigracionBras(data);
    },
    onSuccess: (data) => {
      setAlert(true, data.message, AlertSeverityEnum.success);
    },
    onError: error => {
      handleAxiosError(error)
    },
    onSettled: () => {
    }
  });
}
export const generarMigracionBras = async (data: {bras:string, datos_migracion:MigracionRadius[], verifica_grupo_ip?:boolean}): Promise<any> => {
  const resp = await post<IBras>(`${urlBackend}api/v1/generar-migracion-bras/`, data, true);
  return resp;
}

export const modificarClienteBras = async (data: {old_username:string, username?:string, password?:string, ipv4?:string}): Promise<any> => {
  try {
    return await post<any>(`${urlBackend}api/v1/modificar-cliente-bras/`, data, true);
  } catch (error) {
    toast.error('Error al modificar cliente en el bras: ' + (error as any)?.response?.data?.data);
    throw error;
  }
}


export const usePostReactivarClienteBras = (

) => {

  const queryClient = useQueryClient();
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: async ({ data }: {
      data: {pppoe:string, ip:string, value:string}
    }) => {
      return reactivarClienteBras(data);
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['rad-check'] });
      setAlert(true, data.message, AlertSeverityEnum.success);
    },
    onError: error => {
      handleAxiosError(error)
    },
    onSettled: () => {
    }
  });
}
export const reactivarClienteBras = async (data: {pppoe:string, ip:string, value:string}) => {
  const resp = await post<IBras>(`${urlBackend}api/v1/reactivar-cliente-bras/`, data, true);
  return resp;
}






type CambioEstadoSoftnet = {
  pppoe: string,
  ip?: string,
  cliente_bras: boolean
}
export const usePostEstadoClienteBrasSoftnet = (

) => {

  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: async (data: {user:string, data:CambioEstadoSoftnet[]}) => {
      return estadoClienteBrasSoftnet(data);
    },
    onSuccess: (data) => {
      setAlert(true, data.message, AlertSeverityEnum.success);
    },
    onError: error => {
      handleAxiosError(error)
    },
    onSettled: () => {
    }
  });
}
export const estadoClienteBrasSoftnet = async (data: {user:string, data:CambioEstadoSoftnet[]}) => {
  const resp = await post(`${urlBackend}api/v1/estado-cliente-bras-softnet/`, data, true);
  return resp;
}




/**
 * Hook para migrar clientes a esquema BRAS con seguimiento asíncrono.
 * Retorna el task_id para poder hacer polling del progreso.
 */

// ============ Interfaces para tareas Celery ============
export interface CeleryTaskMigracionBrasStatus {
  task_id: string;
  status: 'PENDING' | 'STARTED' | 'PROGRESS' | 'SUCCESS' | 'FAILURE' | 'RETRY' | 'REVOKED';
  info?: {
    current?: number;
    total?: number;
    percent?: number;
    status?: string;
    ips_created?: number;
    routers_associated?: number;
    mensaje?: string;
  };
  result?: {
    status: string;
    message: string;
    total_created?: number;
    routers_associated?: number;
    grupo_ipv4_id?: string;
  };
  error?: string;
}
export const useMigrarClientesBrasAsync = ({
  onTaskStarted,
  onSuccess,
  onError,
}: {
  onTaskStarted?: (taskId: string, groupData: any) => void;
  onSuccess?: (result: CeleryTaskMigracionBrasStatus['result']) => void;
  onError?: (error: string) => void;
} = {}) => {

  return useMutation({
    mutationFn: generarMigracionBras,
    onSuccess: (response) => {
      if (response && response?.task_id) {
        // La tarea está siendo procesada en segundo plano
        onTaskStarted?.(response?.task_id, response?.data);
      } else {
        // Procesamiento síncrono completado
        // queryClient.invalidateQueries({ queryKey: ['ipv4Groups'] });
        onSuccess?.({ status: 'success', message: response.message });
      }
    },
    onError: (error) => {
      handleAxiosError(error);
      onError?.(error instanceof Error ? error.message : 'Error desconocido');
    },
  });
};
